<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'moi.comments.commentsTitle' | transloco }}</div>
    <div class="detail-page-card-actions">
        @if (permissions.canAddComment) {
            <button class="btn btn-raised" (click)="addClick()">
                <i class="fas fa-plus-circle"></i>
                <span>{{ 'moi.comments.addNewCommentBtn' | transloco }}</span>
            </button>
        }
        <button
            class="btn btn-raised red"
            (click)="deleteClick(selectedComment)"
            [disabled]="!selectedComment || !selectedComment.canDelete"
        >
            <i class="fas fa-minus-circle"></i>
            <span>{{ 'moi.comments.deleteCommentBtn' | transloco }}</span>
        </button>
    </div>

    <div class="detail-page-card-body">
        @if (isLoading) {
            <div class="fancy-loader submodule my-4"></div>
        } @else {
            <div>
                @if (comments && comments.length) {
                    @if (comments.length > 0) {
                        <div class="comments">
                            <div class="row headers">
                                <div class="col-4">{{ 'moi.comments.columnComment' | transloco }}</div>
                                <div class="col-2">{{ 'moi.comments.columnProgress' | transloco }}</div>
                                <div class="col">{{ 'moi.comments.columnType' | transloco }}</div>
                                <div class="col">{{ 'moi.comments.columnFeasibility' | transloco }}</div>
                                <div class="col-2">{{ 'moi.comments.columnUser' | transloco }}</div>
                                <div class="col">{{ 'moi.comments.columnDate' | transloco }}</div>
                            </div>

                            @for (comment of scopedComments; track comment) {
                                <div
                                    class="row comment-row"
                                    [attr.data-uiid]="'moi-comment-row-' + comment.id"
                                    [class.comment-deleted]="comment.isDeleted"
                                    [class.highlight]="
                                        selectedComment && selectedComment.id === comment.id
                                    "
                                    tabindex="0"
                                    (click)="selectedComment = comment"
                                    (dblclick)="editClick(comment)"
                                    (keyup.enter)="selectedComment = comment"
                                >
                                    <div
                                        class="col-4"
                                        [attr.data-uiid]="'moi-comment-comment-' + comment.id"
                                        [matTooltip]="comment.comment ? comment.comment : ''"
                                        matTooltipPosition="after"
                                    >
                                        @if (comment.comment) {
                                            <span
                                            [attr.data-uiid]="'moi-comment-text-' + comment.id"
                                            >{{ comment.comment }}</span>
                                        } @else {
                                            <i style="font-size: 0.8em">{{ 'moi.comments.noCommentGiven' | transloco }}</i>
                                        }
                                    </div>
                                    <div class="col-2">
                                        <div
                                            class="progress"
                                            [matTooltip]="
                                                comment.progress > 0 ? comment.progress + '%' : '-'
                                            "
                                            matTooltipPosition="after"
                                        >
                                            <div
                                                class="progress-bar progress-bar"
                                                [attr.data-uiid]="'moi-comment-progress-' + comment.id"
                                                role="progressbar"
                                                attr.aria-valuenow="{{ comment.progress }}"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                                [ngStyle]="{ width: comment.progress + '%' }"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="col"
                                        [matTooltip]="comment.commentType | moiCommentType"
                                        [attr.data-uiid]="'moi-comment-type-' + comment.id"
                                        matTooltipPosition="after"
                                    >
                                        {{ comment.commentType | moiCommentType }}
                                    </div>
                                    <div
                                        class="col"
                                        data-uiid="moi-comments-comment-feasibility"
                                        [matTooltip]="comment.feasibility"
                                        [attr.data-uiid]="'moi-comment-feasibility-' + comment.id"
                                        matTooltipPosition="after"
                                    >
                                        {{ comment.feasibility }}
                                    </div>
                                    <div class="col-2" [attr.data-uiid]="'moi-comment-created-by-' + comment.id">
                                        {{ comment.createdBy }} <br />
                                        <i>({{ comment.createdByRole }})</i>
                                    </div>
                                    <div class="col" [attr.data-uiid]="'moi-comment-created-at-' + comment.id">{{ comment.createdAt | dateFormat }}</div>
                                </div>
                            }
                        </div>
                    }
                    @if (comments.length > 5) {
                        <div
                            class="more-comments"
                            tabindex="0"
                            (click)="showAllClick(!showAll)"
                            (keyup.enter)="showAllClick(!showAll)"
                        >
                            View {{ showAll ? "last 5 " : "all " + comments.length }} comments
                        </div>
                    }
                } @else {
                    <div class="no-comments">{{ 'moi.comments.noCommentsAvailable' | transloco }}</div>
                }
            </div>
        }
    </div>
</div>
